export const imageCodes = {

    
    proImg: {
        code:"${merchantId}_tmpl_img_2",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fshop.png?alt=media&token=4ee33adb-9007-4b0b-b5d8-53e62f7699d4"
    },

    ninja: {
        code:"${merchantId}_tmpl_img_3",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fa4a4749e78bd2fafb3e5e8f9f98c876db28e77dd.png?alt=media&token=c3d5206b-4605-49bd-9ec8-1ec604775c9b"
    },

    wepoz: {
        code:"${merchantId}_tmpl_img_12",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fwepoz.png?alt=media&token=79b2b539-4dc3-4a2c-a964-bffc035829f6"
    },

    kpay: {
        code:"${merchantId}_tmpl_img_4",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fkpay.png?alt=media&token=8d515287-589a-4a58-957a-5addcd015978"
    },

    wave: {
        code:"${merchantId}_tmpl_img_5",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fwave.jpg?alt=media&token=e81c0e09-496d-4cf9-a790-3291da704d7b"
    },

    addidas: {
        code:"${merchantId}_tmpl_img_6",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Faddidas.png?alt=media&token=04948e6a-841b-407a-a208-9b184c32e0ed"
    },

    nike: {
        code:"${merchantId}_tmpl_img_7",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fnike.png?alt=media&token=d983a412-298d-4eec-9ece-df8eb52616ce"
    },

    slide: {
        code:"${merchantId}_tmpl_img_8",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fslide.png?alt=media&token=fcbc197e-7c63-425e-a6a2-4e310226f8d9"
    },

    clothing: {
        code:"${merchantId}_tmpl_img_9",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fapparels.png?alt=media&token=3232a58b-4200-4f83-8739-2cee7ec81c5c"
    },

    sabina: {
        code:"${merchantId}_tmpl_img_10",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fsabina.png?alt=media&token=cd34f19d-e391-49d6-b5a4-3948113dbfe5"
    },

    heel: {
        code:"${merchantId}_tmpl_img_10",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fheel.png?alt=media&token=f79b337a-72ac-463e-a04d-4f34dff9a3d4"
    },
    
}

export const textCodes = {

    Address: {
        code: "${merchantId}_tmpl_text_1",
        text: "32,81x82 ကြား ဝါကိုးလ်စတိုးအထည်ဆိုင်"
    },

    copyText: {
        code: "${merchantId}_tmpl_title_2",
        text: "- All right reserved by Ncici"
    },
}

export const titleCodes = {
    AddressTitle: {
        code: "${merchantId}_tmpl_title_1",
        title: "Address"
    },
}